import VerticalOptionsMenuUI from './VerticalOptionsMenuUI.js';
import { getOSM } from '../OverworldAnimation.js';

export default class PlayerGenderMenuUI extends VerticalOptionsMenuUI {
    constructor({ menu, position = { x: 240 - 64, y: 112 } } = {}) {
        const actualMenu = menu ?? getOSM().playerGenderMenu;
        super({ menu: actualMenu, position });
    }

    draw() {
        super.draw();
    }
}
